import React, { useContext } from "react";
import { TouchableOpacity } from "react-native";
import { useTheme } from "@emotion/react";
import Text from "../Text";

import {
	Container,
	Body,
	CtaContainer,
	RedoIcon,
	LastReviewedOnLabel,
	CtaText,
} from "./styles";

import { QuizRestartTop, QuizRestartBottom } from "./components/Fx";
import { QuizType, QuizContext } from "../../utils/quiz";
import { LocaleContext, LocaleContextType } from "../../utils/locale";
import { FurnitureContext } from "../../utils/furniture";

type QuizRestartProps = {
	onPress?: () => void;
	dateCompleted?: string;
	children?: React.ReactNode;
};

const QuizRestart = ({
	onPress,
	dateCompleted,
	children,
}: QuizRestartProps) => {
	const { color }: any = useTheme();
	let d = new Date(dateCompleted);
	const { getQuiz } = useContext(QuizContext);
	const furniture = useContext(FurnitureContext);
	const { locale }: LocaleContextType = useContext(LocaleContext);

	const { type: quizType } = getQuiz();
	if (isNaN(d.valueOf())) return null;
	let formatted = d.toLocaleDateString(locale, {
		year: "numeric",
		month: "long",
		day: "numeric",
	});

	const renderBody = (formatted) => {
		return (
			<Body>
				{quizType === QuizType.Informational && (
					<LastReviewedOnLabel
						type="body1"
						style={{ textAlign: "center" }}>
						{furniture.strings.quizReviewLabelLastReviewed}
					</LastReviewedOnLabel>
				)}
				{quizType != QuizType.Informational && (
					<LastReviewedOnLabel type="body1">
						{furniture.strings.quizReviewLabelLastAssessed}
					</LastReviewedOnLabel>
				)}
				<Text type="body1">{formatted}</Text>
				<CtaContainer>
					<RedoIcon width={40} height={40} />
					<CtaText type="body1">
						{furniture.strings.quizReviewLabelClearResults}
					</CtaText>
				</CtaContainer>
			</Body>
		);
	};

	const renderChildren = (children) => {
		return <Body>{children}</Body>;
	};

	return (
		<TouchableOpacity onPress={onPress}>
			<Container>
				<QuizRestartTop
					width="100%"
					style={{ color: color.backgroundAccent }}
				/>
				{children ? renderChildren(children) : renderBody(formatted)}
				<QuizRestartBottom
					width="100%"
					style={{ color: color.backgroundAccent }}
				/>
			</Container>
		</TouchableOpacity>
	);
};

export default QuizRestart;
